import { useState } from "react";
import { Link } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Sparkles, Loader2, MailCheck, ArrowLeft } from "lucide-react";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center relative px-6">
      <div className="grain" />
      <Link to="/" className="absolute top-6 left-6 z-20 inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors" data-testid="auth-back-home">
        <ArrowLeft className="h-4 w-4" /> Tilbage til forsiden
      </Link>
      <div className="relative z-10 w-full max-w-sm">
        <Link to="/" className="flex items-center gap-2 justify-center mb-10">
          <div className="h-7 w-7 rounded-md bg-foreground flex items-center justify-center">
            <Sparkles className="h-4 w-4 text-background" strokeWidth={2} />
          </div>
          <span className="font-display font-bold tracking-tight">Aicom<span className="text-muted-foreground">AI</span></span>
        </Link>

        {sent ? (
          <div className="text-center" data-testid="forgot-sent">
            <MailCheck className="h-12 w-12 mx-auto text-foreground mb-5" strokeWidth={1.5} />
            <h1 className="font-display text-2xl font-medium tracking-tight">Tjek din indbakke</h1>
            <p className="text-muted-foreground mt-3 text-sm leading-relaxed">
              Hvis der findes en konto med <span className="text-foreground">{email}</span>, har vi sendt et link til at nulstille din adgangskode. Linket er gyldigt i 1 time.
            </p>
            <Link to="/login" className="mt-8 inline-flex items-center gap-2 text-sm text-foreground hover:underline" data-testid="forgot-back-login">
              <ArrowLeft className="h-4 w-4" /> Tilbage til log ind
            </Link>
          </div>
        ) : (
          <>
            <h1 className="font-display text-3xl font-medium tracking-tight text-center">Glemt adgangskode?</h1>
            <p className="text-muted-foreground text-center mt-2 text-sm">
              Indtast din e-mail, så sender vi et link til at oprette en ny adgangskode.
            </p>
            <form onSubmit={submit} className="mt-8 space-y-4">
              <div className="space-y-2">
                <Label htmlFor="email">E-mail</Label>
                <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
                  data-testid="forgot-email-input" placeholder="dig@virksomhed.dk" />
              </div>
              <Button type="submit" className="w-full h-11" disabled={loading} data-testid="forgot-submit-btn">
                {loading && <Loader2 className="h-4 w-4 animate-spin mr-2" />}
                Send nulstillingslink
              </Button>
            </form>
            <p className="text-center text-sm text-muted-foreground mt-6">
              <Link to="/login" className="text-foreground hover:underline" data-testid="forgot-login-link">Tilbage til log ind</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
